
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import BubbleToggle from './BubbleToggle';
import LanguageSwitcher from './LanguageSwitcher';
import DarkThemeToggle from './DarkThemeToggle';
import { useTranslation } from '../context/LanguageContext';
import '../styles/Navbar.css';

const Navbar = ({ onLogout }) => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    closeMenu();
  };

  const handleLogout = () => {
    closeMenu();
    onLogout();
  };

  const navbar = createPortal(
    <nav className="navbar">
      <div className="nav-brand" onClick={() => scrollToSection('hero')} role="button" tabIndex={0} style={{ cursor: 'pointer' }}>
        <span>A&G</span>
      </div>

      <ul className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
        {/* Close button inside mobile menu */}
        <li className="nav-item nav-item-close">
          <button onClick={closeMenu} className="nav-close" aria-label="Close menu">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </li>
        <li className="nav-item nav-item-home">
          <button onClick={() => scrollToSection('hero')} className="nav-link">{t('navbar.home')}</button>
        </li>
        <li className="nav-item">
          <button onClick={() => scrollToSection('countdown-timer')} className="nav-link">{t('navbar.countdown')}</button>
        </li>
        <li className="nav-item">
          <button onClick={() => scrollToSection('location-map')} className="nav-link">{t('navbar.location')}</button>
        </li>
        <li className="nav-item">
          <button onClick={() => scrollToSection('suggestions')} className="nav-link">{t('navbar.explore')}</button>
        </li>
        <li className="nav-item">
          <button onClick={() => scrollToSection('rsvp-section')} className="nav-link">{t('navbar.rsvp')}</button>
        </li>
        <li className="nav-item">
          <button onClick={() => scrollToSection('info-section')} className="nav-link">{t('navbar.faqs')}</button>
        </li>
        <li className="nav-item nav-item-utilities">
          <BubbleToggle />
          <LanguageSwitcher />
          <DarkThemeToggle />
        </li>
        <li className="nav-item nav-item-logout">
          <button onClick={handleLogout} className="nav-link nav-logout" aria-label={t('navbar.logout')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </button>
        </li>
        <li className="nav-item nav-item-bottom">
          <LanguageSwitcher />
          <button onClick={handleLogout} className="nav-link nav-logout" aria-label={t('navbar.logout')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            <span className="nav-logout-text">{t('navbar.logout')}</span>
          </button>
        </li>
      </ul>

      {/* Mobile: bubble toggle + theme toggle on navbar */}
      <div className="nav-mobile-controls">
        <BubbleToggle />
        <DarkThemeToggle />
      </div>

      {/* Mobile Burger Menu Button */}
      <button
        className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>,
    document.body
  );

  const overlay = isMenuOpen ? createPortal(
    <div className="nav-overlay" onClick={closeMenu}></div>,
    document.body
  ) : null;

  return (
    <>
      {navbar}
      {overlay}
    </>
  );
};

export default Navbar;
